import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import FarhanPage from './pages/FarhanPage';
import AirdoctorPage from './pages/AirdoctorPage';

const path = window.location.pathname.replace(/\/+$/, '');
const Page =
  path === '/farhan' ? FarhanPage :
  path === '/airdoctor' ? AirdoctorPage :
  App;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><Page /></React.StrictMode>);
